(function () {
  function i(e) {
    if (!window.frames[e]) {
      if (document.body && document.body.firstChild) {
        var t = document.body;
        var n = document.createElement('iframe');
        n.style.display = 'none';
        n.name = e;
        n.title = e;
        t.insertBefore(n, t.firstChild);
      } else {
        setTimeout(function () {
          i(e);
        }, 5);
      }
    }
  }

  function e(n, o, r, f, s) {
    function e(e, t, n, i) {
      if (typeof n !== 'function') {
        return;
      }
      if (!window[o]) {
        window[o] = [];
      }
      var a = false;
      if (s) {
        a = s(e, i, n);
      }
      if (!a) {
        window[o].push({ command: e, version: t, callback: n, parameter: i });
      }
    }

    e.stub = true;
    e.stubVersion = 2;

    function t(i) {
      if (!window[n] || window[n].stub !== true) {
        return;
      }
      if (!i.data) {
        return;
      }
      var a = typeof i.data === 'string';
      var e;
      try {
        e = a ? JSON.parse(i.data) : i.data;
      } catch (t) {
        return;
      }
      if (e[r]) {
        var o = e[r];
        window[n](
          o.command,
          o.version,
          function (e, t) {
            var n = {};
            n[f] = { returnValue: e, success: t, callId: o.callId };
            if (i.source) {
              i.source.postMessage(a ? JSON.stringify(n) : n, '*');
            }
          },
          o.parameter
        );
      }
    }

    if (typeof window[n] !== 'function') {
      window[n] = e;
      if (window.addEventListener) {
        window.addEventListener('message', t, false);
      } else {
        window.attachEvent('onmessage', t);
      }
    }
  }

  e('__tcfapi', '__tcfapiBuffer', '__tcfapiCall', '__tcfapiReturn');
  i('__tcfapiLocator');
})();

(function () {
  (function (e, i, o) {
    var n = document.createElement('link');
    n.rel = 'preconnect';
    n.as = 'script';
    var t = document.createElement('link');
    t.rel = 'dns-prefetch';
    t.as = 'script';
    var r = document.createElement('script');
    r.id = 'spcloader';
    r.type = 'text/javascript';
    r['async'] = true;
    r.charset = 'utf-8';
    window.didomiConfig = window.didomiConfig || {};
    window.didomiConfig.sdkPath = window.didomiConfig.sdkPath || o || 'https://sdk.privacy-center.org/';
    const d = window.didomiConfig.sdkPath;
    var a = d + e + '/loader.js?target_type=notice&target=' + i;
    if (window.didomiConfig && window.didomiConfig.user) {
      var c = window.didomiConfig.user;
      var s = c.country;
      var f = c.region;
      if (s) {
        a = a + '&country=' + s;
        if (f) {
          a = a + '&region=' + f;
        }
      }
    }
    n.href = d;
    t.href = d;
    r.src = a;
    var m = document.getElementsByTagName('script')[0];
    m.parentNode.insertBefore(n, m);
    m.parentNode.insertBefore(t, m);
    m.parentNode.insertBefore(r, m);
  })('4aa02a07-9b2e-47bb-89c3-e269a0655d80', 'xU3B8KyR');
})();
